<template>
    <router-link
            :to="url"
            :class="[
                small?'small':' ',
                left?'left':' '
            ]"
             class="map-point"
            :style="`top:${y}%;left:${x}%;`">
        <div class="line">
            <i></i>
        </div>
        <span class="text">{{label}}</span>
    </router-link>
</template>

<script>
    export default {
        name: "MapPoint",
        props:{
            label:{
                default:"Label ici"
            },
            url:{
                default:"#"
            },
            left:{
                type:Boolean,
                default:false
            },
            small:{
                type:Boolean
            },
            x:{
                default: "50"
            },
            y:{
                default: "50"
            }
        }
    }
</script>

<style lang="less">
    .map-point{
        line-height: 1;
        display: flex;
        align-items: center;
        color: white;
        font-weight: normal;
        text-decoration: none;
        --point-size:0.2vw;
        .line{
            position: relative;
            height: 1px;
            width: 10vw;
            background-color: white;
            i{
                top:1px;
                left: 0;
                @sz:0.2vw;
                position: absolute;
                transform: translateX(-50%) translateY(-50%);
                display: block;
                width:var(--point-size);
                height:var(--point-size);
                border-radius: 100%;
                background-color: white;
            }
        }
        .text{
            margin: 0 1vw;
            font-size: 1vw;
            white-space: nowrap;
            text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.58),-1px -1px 8px rgba(0, 0, 0, 0.58);
        };

        &.small{
            .line{
                width: 1vw;
                background-color: transparent;
                --point-size:1vw;
                i{
                    background:radial-gradient(circle, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%)
                }
            }
        }
        &.left{
            transform:translateX(-100%);
            .line{
                order:2;
                i{
                    left: auto;
                    right: 0;
                    transform: translateX(50%) translateY(-50%);
                }
            }
        }
    }
</style>